import type { PillTone } from '../../components/StatusPill';
import ui from '../../components/ui.module.css';

const toneClass: Record<PillTone, string | undefined> = {
  synced: ui.pillSynced,
  held: ui.pillHeld,
  info: ui.pillInfo,
  pending: ui.pillPending,
  neutral: ui.pillNeutral,
};

/**
 * The portal's status pill with fixed text, for illustrations. StatusPill builds its text from a live time ("6 minutes
 * ago" from now), which would differ between the prerender and the browser; the classes are the same. Every pill's
 * text carries a number or a time, as in the portal.
 */
export function Pill({ tone, children, className }: { tone: PillTone; children: string; className?: string }) {
  return <span className={`${ui.pill} ${toneClass[tone]} ${className ?? ''}`}>{children}</span>;
}
